const overrides = {
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontSize: '2em',
                backgroundColor: '#28333F',
                maxWidth: '12.625rem',
                padding: '0.25rem 0.75rem',
                borderRadius: '0.25rem'                 
            },
            arrow: {
                color : '#28333F'
            }
        }
    }
}

export default overrides;
